import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Loading from 'app/components/loaders/Loading';

import ResignationRequests from 'app/components/resignationrequests/ResignationRequests'

import { paper } from 'app/styles/core';
import { container } from 'app/styles/new-layout';

const useStyles = makeStyles(theme => ({
    container: {
        ...container(theme),
        padding: theme.spacing(3),
    },
    directory: {
        maxWidth: 680,
        margin: '0 auto',
        minHeight: 460
    },
    paper: {
        ...paper(theme),
        position: 'relative'
    },
    gridItemExpand: {
        flexGrow: 1
    },
    searchField: {
        minWidth: '220px'
    },
    pagination: {
        flexWrap: 'wrap',
        justifyContent: 'flex-end'
    }
}));

export default function ResignationRequestsPage(props) {

    const [ loading, setLoading ] = useState(false);
    const classes = useStyles();

    return (
        <form className={classes.container} noValidate autoComplete="off">
            <Typography variant="h3" component="h1" gutterBottom align="center">Resignation Requests</Typography>
            <div className={classes.directory}>
                <Paper className={classes.paper}>
                    <Loading isLoading={loading}/>
                    <ResignationRequests />
                </Paper>
            </div>
        </form>
    );
}
